export enum CreateReportStep {
  LOCATION = 0,
  DUPLICATES = 1,
  CATEGORY = 2,
  DESCRIPTION = 3,
  CONFIRM = 4,
}
